import { useCallback, useEffect, useState, useRef } from 'react';
import styles from './Footer.module.css';
import { motifPaths } from '../data/motifs';
import LandAcknowledgement from './LandAcknowledgement';
import EnvelopeContact from './EnvelopeContact';


const motifs = motifPaths;
const landAcknowledgementText =
        "We live and work on stolen land. The struggle for the rights of Indigenous peoples in Australia is ongoing, and recognising their traditional connection to Country is a small step to restoring dignity to the lives of all Australians.";

function Footer({ setBackToFooter = null }) {

    const titleMotifLeft = motifs.bloom.path;
    const titleMotifRight = motifs.lily.path;
    const bottomMotif = motifs.observer.path;



    return (

        <div id="footer" className={styles.footer}>

            <div className={styles.footerTitle}>
                <svg className={styles.titleMotifLeft}>{titleMotifLeft}</svg>
                <div className={styles.footerTitleText}>Jonathan Liew</div>
                <svg className={styles.titleMotifRight}>{titleMotifRight}</svg>
            </div>
            <div className={styles.footerNavLinks}>
                <a tabIndex="0" href="#about" onClick={() => setBackToFooter(true)} className={styles.footerNavLink}>About</a>
                <a tabIndex="0" href="#design" onClick={() => setBackToFooter(true)} className={styles.footerNavLink}>Design</a>
                <a tabIndex="0" href="#illustration" onClick={() => setBackToFooter(true)} className={styles.footerNavLink}>Illustration</a>
                <a tabIndex="0" href="#services" onClick={() => setBackToFooter(true)} className={styles.footerNavLink}>Services</a>
                {/*<a tabIndex="0" href="#print-digital" onClick={() => setBackToFooter(true)} className={styles.footerNavLink}>Print / Digital</a>
                <a tabIndex="0" href="#events" onClick={() => setBackToFooter(true)} className={styles.footerNavLink}>Events</a>*/}
            </div>
            {/*<div className={styles.footerContactSection}>
                <a className={styles.footerContactButton} title="Send an email to design@jlliew.com" href="mailto:design@jlliew.com">Email me</a>
                <p className={styles.footerContactText}>design@jlliew.com</p>
            </div>*/}
            <EnvelopeContact/>
            {/*<svg className={styles.bottomMotif}>{bottomMotif}</svg>*/}

        </div>

    );
}

export default Footer;
